import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import responsive from 'src/constants/responsive';
import stylesheet, { directions } from 'src/constants/stylesheet';

export type LoadingProps = {};
const rotate = {
    from: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 0)`
    },
    to: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 360deg)`,
    }
};
const size = 23;

const styles = {
    container: {
        position: 'absolute',
        width: size,
        height: size,
        opacity: 0,
        pointerEvents: 'none',
        ...stylesheet.PostionGutter(1, directions.top | directions.right),
        transition: 'apacity, .3s ease',
        '[data-loading="loading"] &': {
            opacity: 1
        },
        [responsive.AfterMobile]: {
            display: 'none',
        }
    },
    loadingElement: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: size,
        height: size,
        borderRadius: 1000,
        border: '1px solid black',
        background: 'transparent',
        animationName: 'rotate',
        animationIterationCount: 'infinite',
        animationDuration: '1s',
        animationTimingFunction: 'linear',
        borderTopColor: 'transparent'
    },
    '@keyframes rotate': rotate
};

type Props =
    LoadingProps &
    StyledComponentProps<keyof typeof styles>;

const Loading: React.FunctionComponent<Props> = (props) => {
    const { classes } = props;
    return (
        <div className={classes!.container} >
            <div className={classes!.loadingElement} />
        </div>
    );
};

export default withStyles(styles)(Loading);


// WEBPACK FOOTER //
// ./src/components/Loading.tsx